import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from "@gemini/ui";
import { StarFilledIcon } from "@gemini/icons";
import { useTags } from "@/hooks";
import { useI18n } from "@/contexts/i18n";
export const Tags = () => {
    const { t } = useI18n();
    const tags = useTags();
    const { isExclusive } = tags;
    return isExclusive ? (_jsx(Tag, { variant: "light", icon: StarFilledIcon, children: t("tags.exclusivity.label") })) : null;
};
